module.exports = __webpack_public_path__ + "static/img/weather59.0220b00d.png";